module.exports = __webpack_public_path__ + "media/app/assets/soulbinds/trait-f1ab632c90ab00e3e992ed8593f626e5.png";